<template>
  <div>
    <div class="contentInner">
      <el-card class="box-card">
        <!-- *标头 -->
        <div slot="header" class="clearfix">
          <span>团长寄样</span>
        </div>
        <!-- *搜索栏 -->
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="商品标题">
              <el-input size="mini" v-model="formInline.title" placeholder="请输入商品标题"></el-input>
            </el-form-item>
            <el-form-item label="商品ID">
              <el-input size="mini" v-model="formInline.id" placeholder="请输入商品ID"></el-input>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input size="mini" v-model="formInline.transprotId" placeholder="请输入物流单号"></el-input>
            </el-form-item>
            <el-form-item label="达人昵称">
              <el-input size="mini" v-model="formInline.name" placeholder="请输入达人昵称"></el-input>
            </el-form-item>
            <el-form-item label="申请时间">
             <el-date-picker
                v-model="timeSelest"
                type="daterange"
                align="right"
                size="mini"
                unlink-panels
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                format='yyyy-MM-dd'
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="danger" @click="onSubmit">搜索</el-button>
              <el-button size="mini" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- *table数据 -->
        <div>
          <!-- *状态选择 -->
          <div class="statusLine">
            <div class="left">
              <div @click="changeStatus(1)" :class="{'active':chooseIndex==1}">
                全部(17)
              </div>
              <div @click="changeStatus(2)" :class="{'active':chooseIndex==2}">
                代发货(17)
              </div>
              <div @click="changeStatus(3)" :class="{'active':chooseIndex==3}">
                快递中(17)
              </div>
              <div @click="changeStatus(4)" :class="{'active':chooseIndex==4}">
                待开播(17)
              </div>
              <div @click="changeStatus(5)" :class="{'active':chooseIndex==5}">
                已开播(17)
              </div>
              <div @click="changeStatus(6)" :class="{'active':chooseIndex==6}">
                已关闭(17)
              </div>
            </div>
            <div class="right">
              <el-button size="mini">导出样品订单</el-button>
              <el-button size="mini">批量发货</el-button>
            </div>
          </div>
          <!-- *底部table数据 -->
           <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            class="table"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              label="带货达人"
              width="180">
              <!-- <template slot-scope="scope"> -->
              <template>
                <div class="sampleInfo">
                  <div class="left">
                     <div class="block"><el-avatar :size="60" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar></div>
                  </div>
                  <div class="right">
                    <span class="name">
                      黄宝宝百货店
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="商品信息"
              width="360"
              show-overflow-tooltip
              >
              <!-- <template slot-scope="scope"> -->
              <template>
                <div class="goodsInfo">
                  <div class="left">
                     <div class="block"><el-avatar shape="square" :size="60" src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"></el-avatar></div>
                  </div>
                  <div class="right">
                    <div class="goodsName">
                      商品名称商品名称商品名称商品名称
                    </div>
                    <div class="goodsId">
                      商品ID：3519999127654128588
                    </div>
                    <div class="goodsPriceInfo">
                      <span>
                        活动价:
                        <span style="color:#45474D">
                          ￥0
                        </span>
                      </span>
                      <span style="padding:0 16px">
                        佣金率:
                        <span style="color:#45474D;">
                          30%
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="合作进度"
              show-overflow-tooltip>
              <!-- <template slot-scope="scope"> -->
              <template>
                <span style="font-size:9px;color:#45474D;font-weight:400;">
                  已关闭
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="info"
              label="合作信息"
              width="200"
              show-overflow-tooltip>
              <!-- <template slot-scope="scope"> -->
              <template>
                <div class="cooperationInfo">
                  <div class="leader">
                    <span>团长：</span>
                    <span style="color:#45474D">托管商品</span>
                  </div>
                  <div class="phone">
                    <span>手机：</span>
                    <span style="color:#45474D">{{18856898956||'--'}}</span>
                  </div>
                  <div class="vchat">
                    <span>微信：</span>
                    <span style="color:#45474D">{{'qwerasdfzxc'||'--'}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="收货地址"
              width="200"
              >
              <!-- <template slot-scope="scope"> -->
              <template>
                <div class="addressInfo">
                  <div class="consignee">
                    <span>收货人：</span>
                    <span style="color:#45474D">托管商品</span>
                  </div>
                  <div class="location">
                    <span>收货地址：</span>
                    <span style="color:#45474D">浙江省杭州市</span>
                  </div>
                  <div class="phoneNumber">
                    <span>收货人手机号：</span>
                    <span style="color:#45474D">{{18856898956||'--'}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="260">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  style="border:none;"
                  @click="handleInfo(scope.$index, scope.row)">
                  <span style="color:#FE2C55;font-size:9px">
                    查看详情
                  </span>
                  </el-button>
                <el-button
                  size="mini"
                  type="text"
                  style="border:none;"
                  @click="handleEdit(scope.$index, scope.row)">
                  <span style="color:#FE2C55;font-size:9px">
                    修改发货信息
                  </span>
                  </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
        return {
          // 表单搜索条件
          formInline: {
            title: '',
            id: '',
            transprotId: '',
            name: '',
            startTime:'',
            endTime:''
          },
          // 时间选择器的返回数组
          timeSelest:[],
          // 日期选择器配置
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
            shortcuts: [{
              text: '今天',
              onClick(picker) {
                picker.$emit('pick', new Date());
              }
            }, {
              text: '昨天',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', date);
              }
            }, {
              text: '一周前',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', date);
              }
            }]
          },
          // 切换条件查询table--默认第一个
          chooseIndex: 1,
          // 列表数据
          tableData:[
            {},
            {},
            {}
          ]
        }
    },
    created(){

    },
    mounted(){
        
    },
    methods:{
      // 重置搜索
      reset(){
        /**
         * @formInline
         */
        // 重置data中的表单初始值
      },
      // 搜索提交
      onSubmit(){
        this.formInline.startTime = this.timeSelest[0]
        this.formInline.endTime = this.timeSelest[1]
      },
      // 切换状态查询
      changeStatus(index){
        this.chooseIndex = index
      },
      // 多选table数据 select--[]
      handleSelectionChange(select){
        
      },
      //通过
      handleInfo(){
        console.log('info');
      },
      //拒绝
      handleEdit(){
        console.log('edit');
      },
    }
  }
</script>

<style lang="scss" scoped>
.contentInner{
  // 去除el-card的下划线
  /deep/.el-card__header{
    border: none;
  }
  /deep/.el-form-item__label{
    font-size: 9px;
    color: #808080;
  }
  /deep/.el-input--mini .el-input__inner{
    width: 120px !important;
  }
  /deep/.el-range-editor--mini.el-input__inner{
    width: 300px !important;
  }
  /deep/.el-table__cell{
    font-size: 9px;
    color: #8A8E99;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  // 
  .demo-form-inline{
    border-bottom: solid 1px #E6E7EB;
  }
  .statusLine{
    // width: 1250px;
    height: 24px;
    margin-top: 14px;
    .left{
      width: 700px;
      height: 24px;
      float: left;
      display: flex;
      line-height: 24px;
      div{
        margin: 0 10px;
        font-size: 11px;
        cursor: pointer;
      }
      .active{
        color: #FE2C55;
        border-bottom: solid 2px #FE2C55;
        margin-bottom: -5px;
      }
    }
    .right{
      width: 200px;
      height: 24px;
      font-size: 9px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #8A8E99;
      line-height: 9px;
      float: right;
    }
  }
  .table{
    margin-top: 12px;
    .sampleInfo{
      display: flex;
      align-items: center;
      .left{
        margin-right: 11px;
      }
      .right{
        display: flex;
        flex-direction: column;
        align-items: center;
        .name{
          color: #FE2C55;
          font-size: 11px;
          font-family: Microsoft YaHei;
          font-weight: 400;
        }
      }
    }
    .goodsInfo{
      display: flex;
      align-items: center;
      .left{
        margin-right: 11px;
      }
      .right{
        .goodsName{
          font-size: 11px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #45474D;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .goodsId{
          font-size: 9px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #8A8E99;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .goodsPriceInfo{
          font-size: 9px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #8A8E99;
        }
      }
    }
    .cooperationInfo{
      font-size: 9px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #8A8E99;
    }
    .addressInfo{
      font-size: 9px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #8A8E99;
    }
  }
}
</style>